import React, { useState, useEffect } from "react";

const formatearTiempo = (segundos) => {
  if (segundos === null || segundos === undefined || Number.isNaN(segundos)) {
    return null;
  }
  const total = Math.max(0, Math.round(segundos));
  const min = Math.floor(total / 60);
  const seg = total % 60;
  return min > 0 ? `${min}:${String(seg).padStart(2, "0")}` : `${seg}s`;
};

const ProgresoPlanillas = ({ progreso }) => {
  const [transcurrido, setTranscurrido] = useState(0);

  useEffect(() => {
    const inicio = Date.now();
    setTranscurrido(0);
    const id = setInterval(
      () => setTranscurrido(Math.round((Date.now() - inicio) / 1000)),
      1000,
    );
    return () => clearInterval(id);
  }, []);

  const esRender = progreso?.fase === "render";
  const porcentaje = esRender ? 100 : progreso?.porcentaje ?? 0;
  const restante = formatearTiempo(progreso?.tiempoRestante);

  return (
    <div style={{ width: "100%", marginBottom: "16px" }}>
      <style>
        {`@keyframes planillasIndeterminado {
            0%   { transform: translateX(-100%); }
            100% { transform: translateX(400%); }
          }`}
      </style>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: "6px",
          fontSize: "12px",
          color: "#0D233E",
          fontWeight: 500,
          gap: "12px",
        }}
      >
        <span>
          {esRender
            ? `Renderizando el PDF${
                progreso?.totalPlanillas
                  ? ` (${progreso.totalPlanillas} planillas)`
                  : ""
              }…`
            : "Recolectando datos…"}
        </span>
        {!esRender && (
          <span style={{ color: "#0072FF", fontWeight: 700 }}>
            {porcentaje}%
          </span>
        )}
      </div>

      <div
        style={{
          width: "100%",
          height: "8px",
          borderRadius: "4px",
          backgroundColor: "#e6edf7",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {esRender ? (
          <div
            style={{
              width: "25%",
              height: "100%",
              borderRadius: "4px",
              backgroundColor: "#0072FF",
              animation: "planillasIndeterminado 1.2s ease-in-out infinite",
            }}
          />
        ) : (
          <div
            style={{
              width: `${porcentaje}%`,
              height: "100%",
              borderRadius: "4px",
              backgroundColor: "#0072FF",
              transition: "width 0.3s ease",
            }}
          />
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "6px",
          fontSize: "11px",
          color: "#798696",
          gap: "12px",
        }}
      >
        <span>
          {esRender
            ? "Esta fase no reporta avance; puede tardar varios minutos."
            : progreso?.total
              ? `${progreso.procesados ?? 0} de ${progreso.total} cursos${
                  progreso?.nombreGrupo ? ` — ${progreso.nombreGrupo}` : ""
                }`
              : "Preparando…"}
        </span>
        <span style={{ whiteSpace: "nowrap" }}>
          {!esRender && restante
            ? `≈ ${restante} restantes`
            : `${formatearTiempo(transcurrido)} transcurridos`}
        </span>
      </div>
    </div>
  );
};

export default ProgresoPlanillas;